import { api } from '@/store/api'

export type BetaUseCase = 'publish' | 'audience' | 'employees' | 'knowledge' | 'explore'

export interface StudioApplicationResponse {
  id: number
  answers: { useCase: BetaUseCase }
  createdAt: string
}

export const betaApi = api.injectEndpoints({
  endpoints: (build) => ({
    submitStudioApplication: build.mutation<StudioApplicationResponse, { useCase: BetaUseCase }>({
      query: ({ useCase }) => ({
        url: 'studio-applications',
        method: 'POST',
        body: { answers: { useCase } },
      }),
      invalidatesTags: ['Me'],
    }),
    getStudioQueueCount: build.query<{ count: number }, void>({
      query: () => 'studio-applications/queue',
    }),
  }),
})

export const { useSubmitStudioApplicationMutation, useGetStudioQueueCountQuery } = betaApi
